import { Loader2, WifiOff } from 'lucide-react'
import type { ConnectionStatus } from '@/core/types/chat'

interface ReconnectingBannerProps {
  status: ConnectionStatus
}

export function ReconnectingBanner({ status }: ReconnectingBannerProps) {
  if (status === 'connected') return null

  return (
    <div className="flex items-center justify-center gap-2 px-3 py-1.5 text-xs font-medium bg-amber-50 text-amber-700 dark:bg-amber-950 dark:text-amber-300 border-b border-amber-200 dark:border-amber-800">
      {status === 'reconnecting' ? (
        <>
          <Loader2 className="h-3 w-3 animate-spin" />
          Reconectando...
        </>
      ) : (
        <>
          <WifiOff className="h-3 w-3" />
          Desconectado
        </>
      )}
    </div>
  )
}
